module.exports = {"master":{"setings":"การตั้งค่า"}}


//////////////////
// WEBPACK FOOTER
// ./src/wording/language/th/master.json
// module id = 710
// module chunks = 63